import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import { translatedText } from "./utils/translatedText";
import { useEffect, useState } from "preact/hooks"

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
 function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        loading,
        query: globalQuery
    } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading,
        query: state.query
    }));

    const initialValue = typeof globalQuery?.query === 'string'
        ? globalQuery.query
        : '';

    const [inputValue, setInputValue] = useState(initialValue);

    useEffect(() => {
        if (typeof globalQuery?.query === 'string') {
            setInputValue(globalQuery.query);
        }
    }, [globalQuery?.query]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    }

    return (
        <main-search>
            <div id="search_page_input-wrapper" class="p-8 lg:p-12 relative">
                <p class="uppercase text-13-120 mb-12">
                    {translatedText("searchResultsFor")}
                </p>

                <div class="border-b border-black-15">
                    <input
                        id="search_input"
                        type="search"
                        name="q"
                        value={inputValue}
                        onChange={handleChange}
                        class="placeholderSearch text-40-100 leading-none uppercase w-full pr-32 lg:text-80-100 md:pr-96"
                        placeholder={translatedText("searchHere")}
                        autoCorrect="off"
                        autoComplete="off"
                        autoCapitalize="off"
                        spellCheck="false"
                    />
                </div>
            </div>

            <div class="ns-serp ns-d-flex ns-flex-column ns-font-inherit ns-my-0"
                data-nosto-element={type}>
                {foundProducts && <Sidebar />}
                <div
                    class="px-8 pb-48 relative lg:px-12"
                    style={{ position: loading ? "relative" : "initial" }}>
                    {children({ loading, foundProducts })}
                </div>
            </div>
        </main-search>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

